import * as React from "react";
import "./styles.scss";
import { Button, Form, Input, Label, Modal } from "semantic-ui-react";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { PlayerCard } from "../../../../services/bedrock";
import { PlayerCardSettingsContext } from "../../Contexts";

interface EditUrlModalProps {
  open: boolean;
  playerCard: PlayerCard;
  onClose: () => void;
}

const EditUrlModal: React.FC<EditUrlModalProps> = ({ open, playerCard, onClose }) => {
  type FormValues = {
    slug: string;
  };

  const { PlayerCards } = useContext(PlayerCardSettingsContext);

  const [isSaving, setIsSaving] = useState(false);
  const {
    reset,
    handleSubmit,
    control,
    formState: { isDirty },
  } = useForm<FormValues>({ defaultValues: { slug: playerCard.slug } });
  useEffect(() => reset({ slug: playerCard.slug }), [playerCard.slug]);

  const saveChanges = useCallback(() => {
    handleSubmit((data: FormValues) => {
      if (!isDirty) return;
      setIsSaving(true);
      PlayerCards.savePlayerCardSlug(playerCard.id, data.slug)
        .then(onClose)
        .finally(() => setIsSaving(false));
    })();
  }, [playerCard, isDirty]);

  return (
    <Modal open={open} size="small" className="playerCardEditUrlModal" onClose={() => onClose()} closeIcon>
      <Modal.Header>Edit Player Card URL</Modal.Header>
      <Modal.Content>
        <Form>
          <Controller
            name="slug"
            control={control}
            rules={{
              required: "This is required.",
              pattern: { value: /^\w+$/, message: "Slug must be alphanumeric." },
            }}
            render={({ field, fieldState: { error } }) => {
              return (
                <Form.Field className="playerCardField" error={!!error}>
                  <Input {...field} placeholder="Slug..." label={playerCard.baseUrl} className="slugInput" />
                  {error && (
                    <Label basic prompt pointing>
                      {error.message}
                    </Label>
                  )}
                </Form.Field>
              );
            }}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button content="Save" disabled={!isDirty} loading={isSaving} primary onClick={saveChanges} />
      </Modal.Actions>
    </Modal>
  );
};
export default EditUrlModal;
